import { render } from "./SurveyYourInfo.vue?vue&type=template&id=4ede509c&ts=true"
import script from "./SurveyYourInfo.vue?vue&type=script&lang=ts"
export * from "./SurveyYourInfo.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__